import ApiService from "./apiservice";

export const ExtraWorkService = {
    InsertExtraWork(payload) {
        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return ApiService.post("InsertExtraWork", payload, headers);
    },
    UpdateExtraWork(payload) {
        return ApiService.post("ExtraWork/UpdateExtraWork", payload);
    },
    GetExtraWork(payload) {
        return ApiService.get("extrawork/getExtraWorkListForPerson", payload);
        //return ApiService.get("ExtraWork/GetExtraWork", payload);
    },
    GetExtraWorkDetail(payload) {
        return ApiService.get("ExtraWork/GetExtraWorkDetail", payload);
    },
    GetExtraWorkDetailForAdmin(payload) {
        return ApiService.get("extrawork/GetextraworkDetailForAdmin", payload);
    },
    OprationOnRequest(payload) {
        return ApiService.post("ExtraWork/OprationOnRequest", payload);
    },
    GetExtraWorkListForAdmin(payload) {
        return ApiService.get("extrawork/GetExtraWorkListForAdmin", payload);
    },
    GetExtraWorkApproveDegree(payload) {
        return ApiService.get("extrawork/GetApproveDegree", payload);
    },
    /**
     * specific extra work
     */
    GetSpecificEWListForAdmins(payload) {
        return ApiService.get("ExtraWork/GetSpecificEWListForAdmins", payload);
    },
    GetSpecificEwDetailForPerson(payload) {
        return ApiService.get("ExtraWork/GetSpecificEwDetailForPerson", payload);
    },
    GetSpecificExtraWorkAmountForSection(payload) {
        return ApiService.get("ExtraWork/GetSpecificExtraWorkAmountForSection", payload);
    },
    GetPersonByExtraWorkBySection(payload) {
        return ApiService.get("ExtraWork/GetPersonByExtraWorkBySection", payload);
    },
    InsertOrUpdateSpecialEW(payload) {
        return ApiService.post("ExtraWork/InsertOrUpdateSpecialEW", payload);
    },
    GetPersonSpecificEw(params) {
        return ApiService.get("ExtraWork/GetPersonSpecificEw", params);
    },
};